import { useEffect } from 'react';

export const TOAST_BOTTOM_VAR = '--pod-toast-bottom';
export const TOAST_GAP_PX = 8;
export const MIN_ROOM_ABOVE_PX = 120;

export const toastBottomAbove = (top: number, viewportHeight: number): number | null =>
  top >= MIN_ROOM_ABOVE_PX && top <= viewportHeight
    ? Math.round(viewportHeight - top + TOAST_GAP_PX)
    : null;

const useToastsAbove = (element: HTMLElement | null): void => {
  useEffect(() => {
    if (!element) return undefined;
    const root = document.documentElement;
    let frame = 0;

    const place = (): void => {
      frame = 0;
      const bottom = toastBottomAbove(element.getBoundingClientRect().top, window.innerHeight);
      if (bottom === null) {
        root.style.removeProperty(TOAST_BOTTOM_VAR);
      } else {
        root.style.setProperty(TOAST_BOTTOM_VAR, `${bottom}px`);
      }
    };

    const schedule = (): void => {
      if (!frame) frame = window.requestAnimationFrame(place);
    };

    place();
    window.addEventListener('scroll', schedule, true);
    window.addEventListener('resize', schedule);
    const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
    if (observer) {
      observer.observe(document.body);
      if (element.parentElement) observer.observe(element.parentElement);
    }

    return () => {
      if (frame) window.cancelAnimationFrame(frame);
      window.removeEventListener('scroll', schedule, true);
      window.removeEventListener('resize', schedule);
      observer?.disconnect();
      root.style.removeProperty(TOAST_BOTTOM_VAR);
    };
  }, [element]);
};

export default useToastsAbove;
